export interface BraintreeSetupItem {
  label?: string;
  className?: string;
  placeholder?: string;
}

export interface BraintreeSetup {
  saveInWallet?: BraintreeSetupItem;
}

export const BraintreeDefaultSetup: BraintreeSetup = {
  //by default, omit saveInWallet
};
